var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "folderModal",
      attrs: {
        id: "folder-modal",
        title: _vm.isEdit ? "Editar Carpeta" : "Nueva Carpeta",
        visible: _vm.visible,
        "hide-footer": "",
        "no-close-on-backdrop": ""
      },
      on: {
        hidden: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "row mb-5" }, [
        _c("div", { staticClass: "col-md-12 mt-3" }, [
          _c("label", [_vm._v("Nombre")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            staticClass: "form-control",
            attrs: { disabled: _vm.isSaving },
            domProps: { value: _vm.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          })
        ]),
        _vm.error
          ? _c("div", { staticClass: "col-md-12 mt-2" }, [
              _c("div", { staticClass: "text-danger" }, [
                _vm._v(" " + _vm._s(_vm.error) + " ")
              ])
            ])
          : _vm._e(),
        _c("div", { staticClass: "col-md-12 mt-3" }, [
          _c(
            "div",
            { staticStyle: { float: "right" } },
            [
              _c(
                "vs-button",
                {
                  staticClass: "action",
                  attrs: {
                    color: "primary",
                    type: "border",
                    icon: "save",
                    disabled: _vm.isSaving
                  },
                  on: { click: _vm.handleSave }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }